import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=f3acc266"
import script from "./addArticle.vue?vue&type=script&lang=js"
export * from "./addArticle.vue?vue&type=script&lang=js"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=f3acc266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports